var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.8688 15.4575C19.3126 12.319 19.0918 7.77838 16.2067 4.89319C13.0825 1.769 8.01714 1.769 4.89295 4.89319C1.76876 8.01739 1.76876 13.0827 4.89295 16.2069C7.77813 19.0921 12.3188 19.3128 15.4573 16.8691C15.4708 16.8844 15.4849 16.8994 15.4996 16.914L19.7422 21.1567C20.1327 21.5472 20.7659 21.5472 21.1564 21.1567C21.5469 20.7661 21.5469 20.133 21.1564 19.7424L16.9138 15.4998C16.8991 15.4852 16.8841 15.4711 16.8688 15.4575ZM14.7924 6.30741C17.1356 8.65055 17.1356 12.4495 14.7924 14.7927C12.4493 17.1358 8.65031 17.1358 6.30716 14.7927C3.96402 12.4495 3.96402 8.65055 6.30716 6.30741C8.65031 3.96426 12.4493 3.96426 14.7924 6.30741Z",
    fill: "#7E8A96"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.5252a598.svg";
export { ForwardRef as ReactComponent };